module.exports = __webpack_public_path__ + "media/images/favicon/favicon-16x16-aaceadc305203eb7d1490b254f28f223.png";